export const ADD_USER_WITH_FORM_REQUEST = 'ADD_USER_WITH_FORM_REQUEST';
export const ADD_USER_WITH_FORM_SUCCESS = 'ADD_USER_WITH_FORM_SUCCESS';
export const ADD_USER_WITH_FORM_FAILED = 'ADD_USER_WITH_FORM_FAILED';
export const ADD_USER_WITH_FORM_RESET = 'ADD_USER_WITH_FORM_RESET';
